<template>
    <a-spin :spinning="boxSpinning">
        <div id="steps-first">
            <h1>基本信息</h1>
            <a-form-model ref="firstForm"
                          :labelCol="{ span: 8 }"
                          :wrapperCol="{ span: 10 }"
                          :model="firstForm.data"
                          :rules="firstForm.rules">
                <a-form-model-item label="来源机构" prop="organizationId">
                    <a-select allowClear show-search :filter-option="filterOption"
                            v-model="firstForm.data.organizationId" placeholder="请选择来源机构"
                            :getPopupContainer="triggerNode => triggerNode.parentNode">
                        <a-select-option :value="item.id" v-for="item in firstForm.treeData" :key="item.id">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item label="报告名称" prop="name">
                    <a-input @change="e => firstForm.data.name = e.target.value.replace(/\s*/g, '')"
                             v-model="firstForm.data.name" placeholder="请输入报告名称"/>
                </a-form-model-item>
                <a-form-model-item label="报告模板" prop="reportTemplateId">
                  <a-tree-select :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                                 placeholder="请选择"
                                 :tree-data="reportTempliteList"
                                 :replaceFields="{ children:'reportTemplates', title:'name', key:'id', value: 'id' }"
                                 allow-clear
                                 treeNodeFilterProp="title"
                                 v-model="firstForm.data.reportTemplateId" />
                </a-form-model-item>
                <!-- <a-form-model-item label="学业成绩">
                    <span v-if="selectedRowKeys.length" class="exam">{{ selectExamName }} <a-icon type="close" class="exicon" @click="clear()"/></span>
                    <a-button type="primary" @click="examination">选择考试</a-button>
                </a-form-model-item> -->
                <a-form-model-item :wrapper-col="{ span: 10, offset: 8 }" style="text-align: right;">
                    <a-button @click="cancel" style="margin-right: 20px;">取消</a-button>
                    <a-button type="primary" @click="onSubmit">下一步 选择课程</a-button>
                </a-form-model-item>
            </a-form-model>
        </div>
        <!-- 选择考试 -->
        <a-modal v-model="ismodle" @ok="examinationOk" @cancel="examinationCancel" width="60%">
            <a-form-model layout="inline" :model="searchForm">
                <a-form-model-item label="考试名称">
                    <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.examName"
                             placeholder="请输入考试名称"/>
                </a-form-model-item>
                <a-form-model-item label="文件名称">
                    <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.fileName"
                             placeholder="请输入文件名称"/>
                </a-form-model-item>
                <a-form-model-item label="关联科目">
                    <a-select class="serach-item" allowClear v-model="searchForm.relatedSubject" placeholder="请选择关联科目">
                        <a-select-option :value="item" v-for="item in subjectList" :key="item.organizationId">{{ item }}</a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item style="margin-right: 35px;">
                    <a-button @click="getExaminationList(1)" type="primary" html-type="button">
                        查询
                    </a-button>
                </a-form-model-item>
            </a-form-model>
            <a-table
                style="min-width: 800px;margin-top: 15px;"
                :columns="columns"
                rowKey="pupilExamId"
                :scroll="{y: 300}"
                :row-selection="rowSelection"
                :pagination="tableRelevant.tablePagination"
                :loading="tableRelevant.tableLoading"
                :locale="tableRelevant.locale"
                :dataSource="tableRelevant.tableDataSource">
                <span slot="examType" slot-scope="text, record">
                    {{ examTypes[text.examType] }}
                </span>
                <span slot="term" slot-scope="text, record">
                    {{ text.term == 0 ? '其他' : text.term == 1 ? '春季' : '秋季' }}
                </span>
            </a-table>
        </a-modal>
    </a-spin>
</template>

<script>
    import {FormatDate} from "@/pages/projectImpl/js/utils";
    import $Bus from "@/pages/projectImpl/js/eventBus";
    import moment from 'moment';
    import {tableRelevant} from "@/pages/projectImpl/js/utils";

    const columns = [
        {title: '考试名称',dataIndex: 'examName',key: 'examName',align: 'center'},
        {title: '考试学期',scopedSlots: { customRender: 'term' },width:100,align: 'center'},
        {title: '考试类型',scopedSlots: { customRender: 'examType' },key: 'examType',align: 'center'},
        {title: '关联科目',dataIndex: 'relatedSubject',key: 'relatedSubject',ellipsis: true, align: 'center'},
        {title: '班级数',dataIndex: 'classCount',key: 'classCount',width:100, align: 'center'},
        {title: '学生数',dataIndex: 'userCount',key: 'userCount',width:100, align: 'center'},
        {title: '文件名称',dataIndex: 'fileName',key: 'fileName',align: 'center'},
    ]
    export default {
        name: "StepsFirst",
        data() {
            return {
                moment,
                reportId: this.$parent.$props.reportId,
                //表单加载loading
                boxSpinning: false,
                reportTempliteList:[],
                reportVersionsList:[],
                reportAbilityList: [],
                firstForm: {
                    isNowTime: true,
                    reportTypeDisabled: false,
                    data: {
                        id: "",
                        name:'',
                        reportTemplateId:undefined,
                        organizationId:undefined,
                        pupilExamId:undefined
                    },
                    rules: {
                        name: [
                            {required: true, message: '请输入报告名称', trigger: 'blur'},
                            {min: 1, max: 50, message: '项目名称长度为 1 到 50个字符', trigger: 'blur'},
                        ],
                        organizationId: [{required: true, message: '请选择机构', trigger: 'change'}],
                        reportTemplateId: [{required: true, message: '请选择报告', trigger: 'change'}],
                    },
                    treeData: []
                },
                ismodle:false,
                searchForm:{
                    examName:'',
                    fileName:'',
                    relatedSubject:undefined
                },
                columns,
                tableRelevant:tableRelevant.call(this,this.getExaminationList),
                examTypes:['其它','入学考试','月考','期中考试','期末考试'],
                selectExamName:'',
                selectedRowKeys:[],
                subjectList:[]
            }
        },
        computed: {
            rowSelection() {
                return {
                    type: 'radio',
                    selectedRowKeys: this.selectedRowKeys,
                    onChange: (selectedRowKeys,selections) => {
                        this.selectExamName = selections[0].examName
                        this.selectedRowKeys = selectedRowKeys;
                    },
                };
            }
        },
        mounted() {
            this.getModel();
            this.getTreeData()
            this.getReportTempliteList()
            this.getreportAbilityList()

        },
        methods: {
            //获取机构
            getTreeData() {
                this.$http.Mechanism.getSuperiorOrg({isOnlySuperior: false}).then(res => {
                    this.firstForm.treeData = res.data
                });
            },
            // 获取报告模板
            getReportTempliteList(){
              this.$http.ReportService.ReportTemplates({Enabled: true}).then(res => {
                this.reportTempliteList = res.data.map((m, i) => {
                  m.id = i;
                  m.selectable = false;
                  m.name = m.templateGroup;
                  m.reportTemplates = m.reportTemplates.map(m1 => ({
                    selectable: true,
                    isLeaf: true,
                    ...m1,
                  }));
                  return m;
                });
              });
            },
            // 报告能力
            getreportAbilityList() {
                let params = {
                    abilityType:0,
                }
                this.$http.reportAbilityList(params)
                    .then(res => {
                            this.reportAbilityList = res.data.data
                           
                    });
            },
            // 机构下拉框搜索
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            //根据id获取团体报告信息
            getModel() {
                if (this.reportId) {
                    this.boxSpinning = true;
                    this.$http.GroupReport.getPersonalReportModel({id: this.reportId}).then(res => {
                        this.$store.commit('organization/setReportInfo', res.data);
                        for (let key in this.firstForm.data) {
                            this.firstForm.data[key] = res.data[key];
                        }
                        this.selectedRowKeys = res.data.pupilExamId ? [res.data.pupilExamId] : []
                        this.selectExamName = res.data.examName
                    }).finally(() => {
                      this.boxSpinning = false;
                    })
                } else {
                    if (this.$store.getters['organization/getReportInfo'].id) {
                        this.reportId = this.$store.getters['organization/getReportInfo'].id;
                        this.getModel();
                    }
                }
            },
            //下一步
            onSubmit() {
                this.$refs["firstForm"].validate(valid => {
                    if (valid) {
                        if (!this.reportId) {
                            delete this.firstForm.data.id;
                        }
                        if (!this.firstForm.data.pupilExamId) {
                            delete this.firstForm.data.pupilExamId;
                        }
                        // this.firstForm.data.status = 0;
                        console.log(this.firstForm);
                        const form = new URLSearchParams(this.firstForm.data);
                        this.boxSpinning = true;
                        this.$http.GroupReport.editPersonalReport(form).then(res => {
                            this.$parent.$data.current = 1;
                            this.firstForm.data.id = Number(res.data) || 324934465565381;
                            const ReportInfo = this.$store.getters['organization/getReportInfo'];
                            for (let key in this.firstForm.data) {
                                ReportInfo[key] = this.firstForm.data[key]
                            }
                            this.$store.commit('organization/setReportInfo', ReportInfo);
                        }).finally(() => {
                          this.boxSpinning = false;
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //取消
            cancel() {
                $Bus.$emit("closeCreateReport");
            },

            // 选择考试
            examination(){
                if(!this.firstForm.data.organizationId){
                    this.$message.destroy();
                    this.$message.warning('请选择机构')
                    return
                }
                this.getExaminationList()
                this.getExtsubject()
                this.ismodle = true
            },
            // 确认选择考试
            examinationOk(){
                if(!this.selectedRowKeys.length){
                    this.$message.destroy();
                    this.$message.warning('请选择考试')
                    return
                }
                this.firstForm.data.pupilExamId = this.selectedRowKeys[0]
                this.ismodle = false
            },
            // 取消
            examinationCancel(){
                this.selectedRowKeys = [];
                this.getModel()
            },
            clear(){
                this.selectedRowKeys = []
                this.selectExamName = ''
                delete this.firstForm.data.pupilExamId;
            },
            getExtsubject(){
                let params = {
                    organizationId:this.firstForm.data.organizationId,
                }
                this.$http.GroupReport.extsubject(params)
                .then(res =>{
                    let arr = []
                    for (var i = 0; i < res.data.length; i++) {
                        arr.push(res.data[i].subjectName)
                    }
                    // 去重后赋值
                    this.subjectList = [...new Set(arr)]
                })
            },
            getExaminationList(pageIndex){
                let params = {
                    ...this.searchForm,
                    pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
                    pageSize: this.tableRelevant.tablePagination.pageSize,
                    organizationId:this.firstForm.data.organizationId,
                }
                this.tableRelevant.tableLoading = true
                this.$http.GroupReport.getExaminationList(params)
                .then(res =>{
                    this.tableRelevant.tableDataSource = res.data.items
                    this.tableRelevant.tablePagination.total = res.data.totalCount;
                    this.tableRelevant.tablePagination.current = res.data.pageIndex;
                }).finally(() => {
                  this.tableRelevant.tableLoading = false
                })
            },
        }
    }
</script>

<style lang="less" scoped>
    #steps-first {
        h1 {
            font-size: 20px;
            color: #333;
            margin-bottom: 30px;
        }
    }
    .exam{
        padding: 2px 30px 2px 10px;
        background: #f1f1f1;
        border-radius: 4px;
        margin-right: 20px;
        position: relative;
    }
    .exicon{
        position: absolute;
        top: 7px;
        right: 8px;
        font-size: 10px;
        cursor: pointer;
    }
</style>
